var _circle, _circle2, _g, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 394,
    height: 356,
    viewBox: "0 0 394 356",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 178,
    cy: 178,
    r: 178,
    fill: "#D9EDF8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_196_828",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 356,
    height: 356
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 178,
    cy: 178,
    r: 178,
    fill: "#E5E7EB"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_196_828)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_196_828)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67 212.063L177.206 131L287.412 212.063H67Z",
    fill: "#293AB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67 358.063H287.412V212.063H67V358.063Z",
    fill: "#293AB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67 358.063L177.206 285.06L67 212.063V358.063Z",
    fill: "#29AAE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.413 358.063L177.207 285.06L287.413 212.063V358.063Z",
    fill: "#29AAE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.206 285.06L150.294 267.234L67 358.063H287.412L204.118 267.234L177.206 285.06Z",
    fill: "#1B92C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.206 285.06L67 212.063L177.206 265.971L287.412 212.063L204.118 267.234L177.206 285.06Z",
    fill: "#202D8A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.119 267.234L287.413 212.063L204.119 267.234Z",
    fill: "#2E8AB0"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M312.999 161.8C348.787 161.8 377.799 132.788 377.799 97C377.799 61.2119 348.787 32.2 312.999 32.2C277.211 32.2 248.199 61.2119 248.199 97C248.199 132.788 277.211 161.8 312.999 161.8ZM343.027 86.5275C346.19 83.3643 346.19 78.2356 343.027 75.0724C339.864 71.9091 334.735 71.9091 331.572 75.0724L304.899 101.745L294.427 91.2724C291.264 88.1091 286.135 88.1091 282.972 91.2724C279.808 94.4356 279.808 99.5643 282.972 102.728L299.172 118.928C302.335 122.091 307.464 122.091 310.627 118.928L343.027 86.5275Z",
    fill: "url(#paint0_linear_196_828)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M343.428 86.8276C346.591 83.6643 346.591 78.5357 343.428 75.3724C340.264 72.2092 335.136 72.2092 331.972 75.3724L305.3 102.045L294.828 91.5724C291.664 88.4092 286.536 88.4092 283.372 91.5724C280.209 94.7357 280.209 99.8643 283.372 103.028L299.572 119.228C302.736 122.391 307.864 122.391 311.028 119.228L343.428 86.8276Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_196_828",
    x: 52,
    y: 116,
    width: 250.414,
    height: 257.063,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.160784 0 0 0 0 0.666667 0 0 0 0 0.886274 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_196_828"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_196_828",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_196_828",
    x1: 269,
    y1: 52,
    x2: 355.5,
    y2: 146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91C83E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#587B23"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailSuccess);
export default __webpack_public_path__ + "static/media/email-success.a94a4ef9512727549794b0ae38772160.svg";
export { ForwardRef as ReactComponent };